/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Skeleton,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import icon_check from "@assets/img/check_black.svg";
import { ButtonTypeSelectedCustom } from "@components/ButtonTypeSelectedCustom";
import { CustomDialog } from "@components/CustomDialog";
import * as yup from "yup";
import { useFormik } from "formik";
import { customStylesAsterisk } from "@components/customStylesInputs/inputsStyles";
import { StyledSlider } from "@components/CustomSlider";
import { formatCurrency } from "@helpers/funciones";
import useInterfaceConfig from "@hooks/useInterfaceConfig";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import VehiculosTable from "./TableVehicles";
// removed unused tableHeaderText import
import { SelectChangeEvent } from "@mui/material/Select";
import {
  useLazyGetVehiclesYearsQuery,
  useLazyGetVehiclesByYearQuery,
  useLazyGetVehiclesByYearAndMakeQuery,
  useLazyGetVehiclesByYearMakeAndModelQuery,
  useLazyGetPriceVehiclesByVersionQuery,
} from "@api/catalogs";
import { ApiError, CarVersionPrice, LoanCondiciones, TaxSystem, VehicleStrutureCatalog } from "@interfaces/index";
import { LeasingPost } from "@interfaces/LeasingTypes";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "@store/store";
import { usePostLeasingMutation } from "@api/leasing";
import { useNavigate } from "react-router-dom";
import { setModalErrorVisible } from "@store/slices/appSlice";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { usePostValidateNextStageMutation, usePutConditionMutation } from "@api/applications";
import * as Sentry from "@sentry/react";
import useStatusConfig from "@hooks/useStatusConfig";
import { setLoanStatus } from "@store/slices/registerSlice";

const SCREEN_STATUS = "CSDVE";
interface FormByMultiVehiclesProps {
  isLoading?: boolean;
  termMarket?: number[];
  residualPercentageMarket?: { value: number; label: string }[];
  taxConfig?: TaxSystem | null;
  maxAmoutSelected?: number | null;
  advancePercentageMarket?: { value: number; label: string }[];
  conditions: LoanCondiciones | null;
}

const FormByMultiVehicles: React.FC<FormByMultiVehiclesProps> = ({
  isLoading,
  termMarket,
  residualPercentageMarket,
  taxConfig,
  maxAmoutSelected,
  advancePercentageMarket,
  conditions,
}) => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const interfaceConfig = useInterfaceConfig();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { nextStatus } = useStatusConfig(SCREEN_STATUS);

  const isShortScreen = useMediaQuery("(max-height:820px)");
  const [vehicleType, setVehicleType] = useState<string>("cars");
  const [listYears, setListYears] = useState<string[]>([]);
  const [brandsOptions, setBrandsOptions] = useState<VehicleStrutureCatalog[]>([]);
  const [modelsOptions, setModelsOptions] = useState<VehicleStrutureCatalog[]>([]);
  const [versionsOptions, setVersionsOptions] = useState<VehicleStrutureCatalog[]>([]);
  const [isLoadingForm, setIsLoadingForm] = useState(false);

  const [selectedTerm, setSelectedTerm] = useState<number>(0);
  const [selectedAdvance, setSelectedAdvance] = useState<number>(20);
  const [selectedResidual, setSelectedResidual] = useState<number>(0);
  const [openAddVehicle, setOpenAddVehicle] = useState<boolean>(false);
  const [editIndex, setEditIndex] = useState<number | null>(null);

  const [terms, setTerms] = useState<number[]>([]);
  const amount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  const [residualMarks, setResidualMarks] = useState<Array<{ value: number; label: string }>>([]);
  const [configResidual, setConfigResidual] = useState({ min: 10, max: 35, step: 5, def: 20 });
  const [configAdvance, setConfigAdvance] = useState({ min: 10, max: 35, step: 5, def: 20 });

  const [vehicleValue, setVehicleValue] = useState<number>(0);
  const [vehicleValueDetail, setVehicleValueDetail] = useState<CarVersionPrice | null>(null);
  const [displayPrice, setDisplayPrice] = useState<string>("");
  const [submitError, setSubmitError] = useState<string>("");

  const application = useSelector((state: RootState) => state.register.application);
  const accountUser = useSelector((state: RootState) => state.register.account_user);

  const [vehicles, setVehicles] = useState<Array<LeasingPost & { unit_price: number }>>([]);

  const [triggerListVehicleYears] = useLazyGetVehiclesYearsQuery();
  const [triggerGetVehicleByYear] = useLazyGetVehiclesByYearQuery();
  const [triggerGetVehicleByYearAndBrand] = useLazyGetVehiclesByYearAndMakeQuery();
  const [triggerGetVehicleByYearBrandAndModel] = useLazyGetVehiclesByYearMakeAndModelQuery();
  const [triggerGetPriceVehiclesByVersion] = useLazyGetPriceVehiclesByVersionQuery();
  const [postLeasing] = usePostLeasingMutation();
  const [putCondition] = usePutConditionMutation();
  const [triggerPostNextStage] = usePostValidateNextStageMutation();

  const formik = useFormik({
    initialValues: {
      type_vehicle: "",
      year: "",
      brand: "",
      brand_value: "",
      model: "",
      model_value: "",
      version: "",
      version_value: "",
      advance: null,
      residual: null,
      carAmount: null,
      price: null,
    },
    validationSchema: yup.object().shape({
      year: yup.string().required("Campo requerido"),
      brand: yup.string().required("Campo requerido"),
      model: yup.string().required("Campo requerido"),
      version: yup.string().required("Campo requerido"),
      advance: yup.number().required("Campo requerido"),
      residual: yup.number().required("Campo requerido"),
      carAmount: yup.number().required("Campo requerido"),
      price: yup.number().required("Campo requerido"),
    }),
    onSubmit: async (values) => {
      const qty = Number(values.carAmount || 1);
      const details = {
        vehicle_type: vehicleType === "cars" ? "Autos" : "Camiones",
        year: Number(values.year),
        make: values.brand_value || values.brand,
        model: values.model_value || values.model,
        version: values.version_value || values.version,
        car_version_code: vehicleType === "cars" ? vehicleValueDetail?.car_version_id || 0 : undefined,
        estimated_mileage: vehicleValueDetail?.mileage || 0,
      };

      const valuesDetails: LeasingPost = {
        loan_application_id: String(application?.id) || "",
        estimated_value: values.price || 0,
        details,
        quantity: qty,
        requested_advance_percentage: selectedAdvance,
        requested_residual_percentage: selectedResidual,
      };

      if (editIndex !== null) {
        setVehicles((prev) =>
          prev.map((it, i) => (i === editIndex ? { ...valuesDetails, unit_price: vehicleValue } : it)),
        );
        setEditIndex(null);
      } else {
        setVehicles((prev) => [...prev, { ...valuesDetails, unit_price: vehicleValue }]);
      }
      setOpenAddVehicle(false);
      formik.resetForm();
      setBrandsOptions([]);
      setModelsOptions([]);
      setVersionsOptions([]);
      setVehicleValue(0);
      setVehicleValueDetail(null);
    },
  });

  useEffect(() => {
    formik.setFieldValue("advance", selectedAdvance);
    formik.setFieldValue("residual", selectedResidual);
  }, [selectedAdvance, selectedResidual]);

  // Al abrir el modal, asegura sembrar los valores de cálculo en Formik para no obligar a mover sliders
  useEffect(() => {
    if (openAddVehicle) {
      formik.setFieldValue("advance", selectedAdvance);
      formik.setFieldValue("residual", selectedResidual);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openAddVehicle]);

  // Cargar años de vehículos (autos/SUVs)
  useEffect(() => {
    const fetchYears = async () => {
      try {
        const response = await triggerListVehicleYears().unwrap();
        setListYears(response);
      } catch (error) {
        const apiError = error as ApiError;

        dispatch(setModalErrorVisible({ open: true, error: apiError }));
      }
    };
    fetchYears();
  }, []);

  // Configuración de rangos/términos basada en props
  useEffect(() => {
    // términos
    if (termMarket && termMarket.length) {
      setTerms(termMarket);
      setSelectedTerm(termMarket[0] ?? 0);
    }

    // marcas para sliders (residual/anticipo)
    if (residualPercentageMarket && residualPercentageMarket.length) {
      setResidualMarks(residualPercentageMarket);
    }

    // configuración de sliders por taxConfig
    if (taxConfig) {
      setConfigResidual({
        min: Number(taxConfig?.min_residual_percentage ?? 10),
        max: Number(taxConfig?.max_residual_percentage ?? 35),
        step: Number(taxConfig?.jump_residual_percentage ?? 5),
        def: Number(taxConfig?.default_residual_percentage ?? 20),
      });

      setConfigAdvance({
        min: Number(taxConfig?.min_advance_percentage ?? 10),
        max: Number(taxConfig?.max_advance_percentage ?? 35),
        step: Number(taxConfig?.jump_advance_percentage ?? 5),
        def: Number(taxConfig?.default_advance_percentage ?? 20),
      });

      setSelectedResidual(Number(taxConfig?.default_residual_percentage ?? 20));
      setSelectedAdvance(Number(taxConfig?.default_advance_percentage ?? 20));
    }
  }, [termMarket, residualPercentageMarket, taxConfig]);

  // Handlers cascada selects
  const handleYearChange = async (e: SelectChangeEvent<string>) => {
    try {
      const value = e.target.value as string;
      formik.setFieldValue("year", value);
      setIsLoadingForm(true);

      const res = value ? await triggerGetVehicleByYear({ year: value }).unwrap() : [];
      setBrandsOptions(res);
      setModelsOptions([]);
      setVersionsOptions([]);

      formik.setFieldValue("brand", "");
      formik.setFieldValue("brand_value", "");
      formik.setFieldValue("model", "");
      formik.setFieldValue("model_value", "");
      formik.setFieldValue("version", "");
      formik.setFieldValue("version_value", "");
    } catch (error) {
      const apiError = error as ApiError;

      dispatch(setModalErrorVisible({ open: true, error: apiError }));
    } finally {
      setIsLoadingForm(false);
    }
  };

  const handleBrandChange = async (e: SelectChangeEvent<string>) => {
    try {
      setIsLoadingForm(true);
      const value = e.target.value as string;
      const year = formik.values.year;

      const selectedBrand = brandsOptions.find((b) => b.code === value);
      formik.setFieldValue("brand", value);
      formik.setFieldValue("brand_value", selectedBrand?.name || "");

      const res = value ? await triggerGetVehicleByYearAndBrand({ year, make: value }).unwrap() : [];
      setModelsOptions(res);
      setVersionsOptions([]);

      formik.setFieldValue("model", "");
      formik.setFieldValue("model_value", "");
      formik.setFieldValue("version", "");
      formik.setFieldValue("version_value", "");
    } catch (error) {
      const apiError = error as ApiError;

      dispatch(setModalErrorVisible({ open: true, error: apiError }));
    } finally {
      setIsLoadingForm(false);
    }
  };

  const handleModelChange = async (e: SelectChangeEvent<string>) => {
    try {
      setIsLoadingForm(true);
      const value = e.target.value as string;
      const year = formik.values.year;
      const brand = formik.values.brand;

      const selectedModel = modelsOptions.find((m) => m.code === value);
      formik.setFieldValue("model", value);
      formik.setFieldValue("model_value", selectedModel?.name || "");

      const res = await triggerGetVehicleByYearBrandAndModel({ year, make: brand, model: value }).unwrap();
      setVersionsOptions(res);

      formik.setFieldValue("version", "");
      formik.setFieldValue("version_value", "");
    } catch (error) {
      const apiError = error as ApiError;

      dispatch(setModalErrorVisible({ open: true, error: apiError }));
    } finally {
      setIsLoadingForm(false);
    }
  };

  const handleVersionChange = async (e: SelectChangeEvent<string>) => {
    try {
      setIsLoadingForm(true);
      const value = e.target.value as string;
      const selectedVersion = versionsOptions.find((b) => b.code === value);
      const response = await triggerGetPriceVehiclesByVersion({ version: value }).unwrap();

      formik.setFieldValue("version", value);
      formik.setFieldValue("version_value", selectedVersion?.name || "");
      formik.setFieldValue("price", response.sale_price);
      setVehicleValue(response.sale_price);
      setVehicleValueDetail(response);
    } catch (error) {
      const apiError = error as ApiError;

      dispatch(setModalErrorVisible({ open: true, error: apiError }));
    } finally {
      setIsLoadingForm(false);
    }
  };

  const startEdit = async (index: number) => {
    try {
      setSubmitError("");
      const v = vehicles[index];
      setEditIndex(index);
      const det = v.details;
      const isCars = (det?.vehicle_type || "").includes("Autos");
      setVehicleType(isCars ? "cars" : "trucks");
      const adv = v.requested_advance_percentage ?? selectedAdvance;
      const res = v.requested_residual_percentage ?? selectedResidual;
      setSelectedAdvance(adv);
      setSelectedResidual(res);
      formik.setFieldValue("advance", adv);
      formik.setFieldValue("residual", res);
      // cantidad
      formik.setFieldValue("carAmount", v.quantity || 1);

      // año siempre como string para selects
      const yearStr = String(det?.year || "");
      formik.setFieldValue("year", yearStr);

      if (isCars) {
        setIsLoadingForm(true);
        try {
          const brandsRes = await triggerGetVehicleByYear({ year: yearStr }).unwrap();
          setBrandsOptions(brandsRes);
          const brandOpt = brandsRes.find((b) => b.name === (det?.make || ""));
          if (brandOpt) {
            formik.setFieldValue("brand", brandOpt.code);
            formik.setFieldValue("brand_value", brandOpt.name);

            const modelsRes = await triggerGetVehicleByYearAndBrand({ year: yearStr, make: brandOpt.code }).unwrap();
            setModelsOptions(modelsRes);
            const modelOpt = modelsRes.find((m) => m.name === (det?.model || ""));
            if (modelOpt) {
              formik.setFieldValue("model", modelOpt.code);
              formik.setFieldValue("model_value", modelOpt.name);

              const versionsRes = await triggerGetVehicleByYearBrandAndModel({
                year: yearStr,
                make: brandOpt.code,
                model: modelOpt.code,
              }).unwrap();
              setVersionsOptions(versionsRes);

              const versionOpt = versionsRes.find((vv) => vv.name === (det?.version || ""));
              if (versionOpt) {
                formik.setFieldValue("version", versionOpt.code);
                formik.setFieldValue("version_value", versionOpt.name);
                const price = await triggerGetPriceVehiclesByVersion({ version: versionOpt.code }).unwrap();
                setVehicleValue(price.sale_price);
                setVehicleValueDetail(price);
                formik.setFieldValue("price", price.sale_price);
              }
            }
          }
        } catch (error) {
          const apiError = error as ApiError;

          dispatch(setModalErrorVisible({ open: true, error: apiError }));
        } finally {
          setIsLoadingForm(false);
        }
      } else {
        // trucks: setear campos texto y valor unitario
        formik.setFieldValue("brand", det?.make || "");
        formik.setFieldValue("brand_value", det?.make || "");
        formik.setFieldValue("model", det?.model || "");
        formik.setFieldValue("model_value", det?.model || "");
        formik.setFieldValue("version", det?.version || "");
        formik.setFieldValue("version_value", det?.version || "");

        setVehicleValue(v.unit_price || 0);
        formik.setFieldValue("price", v.unit_price || 0);
        setVehicleValueDetail(null);
      }

      setOpenAddVehicle(true);
    } catch (error) {
      const apiError = error as ApiError;

      dispatch(setModalErrorVisible({ open: true, error: apiError }));
    }
  };

  const leasingTotals = useMemo(() => {
    const totalValue = vehicles.reduce((acc, v) => acc + (v.unit_price || 0) * (v.quantity || 1), 0);
    const advanceAmount = totalValue * (selectedAdvance / 100);
    const residualAmount = vehicles.reduce((acc, v) => {
      const residualPercentage = v.requested_residual_percentage ?? selectedResidual;
      return acc + (v.unit_price || 0) * (v.quantity || 1) * (residualPercentage / 100);
    }, 0);
    const amountToFinance = totalValue - advanceAmount;

    const totalResidualPercentage = totalValue > 0 ? (residualAmount / totalValue) * 100 : 0;

    const annualRate = interfaceConfig?.interest_rate ?? 0;
    const normalizedAnnualRate = annualRate > 1 ? annualRate / 100 : annualRate;
    const monthlyRate = normalizedAnnualRate / 12;

    const i = monthlyRate;
    const n = selectedTerm;
    const P = amountToFinance;
    const F = residualAmount;

    const monthlyRent =
      i > 0 && n > 0 ? ((P - F / Math.pow(1 + i, n)) * i) / (1 - Math.pow(1 + i, -n)) : n > 0 ? (P - F) / n : 0;

    return { totalValue, advanceAmount, residualAmount, amountToFinance, monthlyRent, totalResidualPercentage };
  }, [vehicles, selectedAdvance, selectedResidual, selectedTerm, interfaceConfig?.interest_rate]);

  const handleContinue = async () => {
    try {
      // Validar monto total contra maxAmoutSelected antes de postear
      const totalValue = vehicles.reduce((acc, v) => acc + (v.unit_price || 0) * (v.quantity || 1), 0);
      const max = Number(maxAmoutSelected ?? 0);
      if (max > 0 && totalValue > max) {
        setSubmitError(
          `El valor total de los vehículos sobrepasa el monto seleccionado. Monto máximo permitido: ${formatCurrency(
            max,
          )}`,
        );
        return;
      } else {
        setSubmitError("");
      }

      const advanceValue = round2(leasingTotals.totalValue * (selectedAdvance / 100));
      const residualValue = round2(leasingTotals.totalValue * (leasingTotals.totalResidualPercentage / 100));

      const data = {
        loan_application: application.id,
        loan_amount: conditions?.selected_amount,
        requested_term: selectedTerm || 0,
        selected_amount: conditions?.selected_amount,
        selected_term: selectedTerm || 0,
        requested_amount: conditions?.selected_amount,
        selected_advance_percentage: selectedAdvance,
        selected_residual_percentage: leasingTotals.totalResidualPercentage,
        selected_advance_value: advanceValue,
        selected_residual_value: residualValue,
        requested_advance_percentage: selectedAdvance,
        requested_residual_percentage: leasingTotals.totalResidualPercentage,
        requested_advance_value: advanceValue,
        requested_residual_value: residualValue,
      };
      await putCondition({ body: data, id: String(conditions?.id) }).unwrap();

      const leasings_list = vehicles.map((v) => {
        const { unit_price, ...rest } = v;
        void unit_price;
        return rest;
      });
      const leasingPost = { leasings_list };

      await postLeasing({ data: leasingPost, id_solicitud: String(application?.id) }).unwrap();
      await triggerPostNextStage({
        applicationId: application.id,
        statusCode: String(nextStatus?.code || ""),
        username: `TOFU - ${accountUser.email}`,
      }).unwrap();

      dispatch(setLoanStatus(String(nextStatus?.code)));

      navigate(String(nextStatus?.url || ""));
    } catch (error) {
      const apiError = error as ApiError;
      Sentry.captureException(error, {
        extra: {
          component: "DetalleVehiclulosArrendamiento-submit",
        },
      });
      dispatch(setModalErrorVisible({ open: true, error: apiError }));
    }
  };

  const round2 = (n: number) => Math.round((n + Number.EPSILON) * 100) / 100;

  useEffect(() => {
    const priceNum = Number(formik.values.price ?? 0);
    if (priceNum > 0) {
      setDisplayPrice(new Intl.NumberFormat("es-MX").format(priceNum));
    } else {
      setDisplayPrice("");
    }
  }, [formik.values.price]);

  const openModal = () => {
    formik.resetForm();
    setVehicleType("cars");
    setEditIndex(null);
    setSubmitError("");
    setOpenAddVehicle(true);
  };

  return (
    <>
      {isLoading ? (
        <>
          <Skeleton variant="rectangular" animation="wave" width={"100%"} height={56} />
          <Box sx={{ mt: 2 }}>
            <Skeleton variant="rectangular" animation="wave" width={"100%"} height={56} />
          </Box>
          <Box sx={{ mt: 2 }}>
            <Skeleton variant="rectangular" animation="wave" width={"100%"} height={56} />
          </Box>
          <Box sx={{ mt: 2 }}>
            <Skeleton variant="rectangular" animation="wave" width={"100%"} height={56} />
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <Skeleton variant="rectangular" animation="wave" width={160} height={40} />
          </Box>
        </>
      ) : (
        <>
          <Box mx={4}>
            {vehicles.length > 0 && (
              <VehiculosTable
                headerBgColor={theme?.palette?.otherColors?.extra_light}
                headerTextColor={theme?.palette?.primary?.dark}
                borderColor={theme?.palette?.primary?.light}
                iconEdit={theme?.palette?.primary?.dark}
                iconDelete={theme?.palette?.primary?.main}
                bodyTextColor={theme?.palette?.primary?.dark}
                onDelete={(index) => setVehicles((prev) => prev.filter((_, i) => i !== index))}
                onEdit={(index) => startEdit(index)}
                rows={vehicles.map((v) => ({
                  vehiculo: `${v.details?.make || ""} ${v.details?.model || ""} ${v.details?.version || ""}, ${
                    v.details?.year || ""
                  }`,
                  cantidad: v.quantity || 1,
                  monto: `${formatCurrency((v.unit_price || 0) * (v.quantity || 1))} ${
                    interfaceConfig.cotizador?.current_currency || "MXN"
                  }`,
                  residual: `${v.requested_residual_percentage ?? selectedResidual}%`,
                }))}
                isLoading={isLoadingForm}
              />
            )}
          </Box>
          <Box display={"flex"} justifyContent={"center"} mt={2}>
            <Button
              variant="default"
              sx={{ width: 160, fontSize: "12px", padding: 1 }}
              onClick={openModal}
              disabled={isLoadingForm}
            >
              <ControlPointIcon sx={{ mr: 1 }} /> Agregar Vehículo
            </Button>
          </Box>

          {submitError && (
            <Box mt={2}>
              <Alert severity="error">{submitError}</Alert>
            </Box>
          )}

          <CustomDialog
            open={openAddVehicle}
            onClose={() => {
              setOpenAddVehicle(false);
              setEditIndex(null);
            }}
            colorClose="#404657"
            closeBgColor="#F0F1F6"
            closeButtonSize={28}
            closeIconSize={20}
            itemTitle={
              <Typography color={theme?.palette?.primary?.dark} fontWeight={400} fontSize={"14px"} textAlign={"center"}>
                Selecciona el tipo de vehículo
              </Typography>
            }
            itemContent={
              <Box width={isMobileOrTablet ? "100%" : "400px"}>
                <Grid container spacing={isMobileOrTablet ? 2 : 2} mt={1} mr={isMobileOrTablet ? 1 : 0}>
                  <Grid item xs={6} md={6} display="flex" justifyContent={"flex-end"}>
                    {!isLoadingForm ? (
                      <ButtonTypeSelectedCustom
                        title="Autos o SUVs"
                        onClick={() => setVehicleType("cars")}
                        isSelected={vehicleType === "cars"}
                        isMovile={isMobileOrTablet}
                        height={isShortScreen ? "60px" : "70px"}
                        heightMoviles="60px"
                        width={isShortScreen ? "180px" : "190px"}
                        widthMoviles="160px"
                        icon={icon_check}
                        width_icon="22px"
                        height_icon="22px"
                        font_size={isShortScreen ? "14px" : "14px"}
                        top_icon="-12px"
                        font_size_movil="11px"
                        font_weight={600}
                        bgColor={theme?.palette?.otherColors?.extra_light}
                        borderColor={theme?.palette?.primary?.light}
                        bgColorActive={theme?.palette?.primary?.light}
                        hoverBgColor={theme?.palette?.primary?.light}
                        hoverTextColor={theme?.palette?.primary?.dark}
                        textColor={theme?.palette?.primary?.dark}
                        textColorActive={theme?.palette?.primary?.dark}
                      />
                    ) : (
                      <Skeleton
                        variant="rectangular"
                        animation="wave"
                        width={isMobileOrTablet ? 150 : 190}
                        height={isMobileOrTablet ? 60 : 70}
                      />
                    )}
                  </Grid>
                  <Grid item xs={6} md={6} display="flex" justifyContent={"flex-start"}>
                    {!isLoadingForm ? (
                      <ButtonTypeSelectedCustom
                        title="Vans o camiones"
                        onClick={() => setVehicleType("trucks")}
                        isSelected={vehicleType === "trucks"}
                        isMovile={isMobileOrTablet}
                        height={isShortScreen ? "60px" : "70px"}
                        heightMoviles="60px"
                        width={isShortScreen ? "180px" : "200px"}
                        widthMoviles="160px"
                        icon={icon_check}
                        width_icon="22px"
                        height_icon="22px"
                        font_size={isShortScreen ? "14px" : "14px"}
                        top_icon="-12px"
                        font_size_movil="11px"
                        font_weight={600}
                        bgColor={theme?.palette?.otherColors?.extra_light}
                        borderColor={theme?.palette?.primary?.light}
                        bgColorActive={theme?.palette?.primary?.light}
                        hoverBgColor={theme?.palette?.primary?.light}
                        hoverTextColor={theme?.palette?.primary?.dark}
                        textColor={theme?.palette?.primary?.dark}
                        textColorActive={theme?.palette?.primary?.dark}
                      />
                    ) : (
                      <Skeleton
                        variant="rectangular"
                        animation="wave"
                        width={isMobileOrTablet ? 150 : 190}
                        height={isMobileOrTablet ? 60 : 70}
                      />
                    )}
                  </Grid>
                </Grid>
                <Box>
                  <Typography
                    textAlign={"center"}
                    variant={"body1"}
                    fontWeight={400}
                    color={theme?.palette?.primary?.dark}
                    mt={4}
                  >
                    Selecciona el vehículo
                  </Typography>
                </Box>

                <form onSubmit={formik.handleSubmit} noValidate>
                  {vehicleType === "trucks" ? (
                    <>
                      <TextField
                        fullWidth
                        label="Año"
                        name="year"
                        value={formik.values.year}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,4}$/.test(value)) {
                            formik.handleChange(e);
                          }
                        }}
                        onBlur={formik.handleBlur}
                        id="year"
                        margin="normal"
                        required
                        autoComplete="off"
                        error={formik.touched.year && Boolean(formik.errors.year)}
                        helperText={formik.touched.year && formik.errors.year}
                        inputProps={{ maxLength: 4 }}
                      />
                    </>
                  ) : (
                    <>
                      {isLoadingForm ? (
                        <Box sx={{ mt: 2 }}>
                          <Skeleton variant="rectangular" animation="wave" width={"100%"} height={56} />
                        </Box>
                      ) : (
                        <FormControl
                          fullWidth
                          required
                          sx={{
                            ...customStylesAsterisk,
                            mt: 3,
                          }}
                          error={formik.touched.year && Boolean(formik.errors.year)}
                        >
                          <InputLabel id="year">Año</InputLabel>
                          <Select
                            labelId="year"
                            id="year"
                            name="year"
                            fullWidth
                            required
                            label="Año"
                            value={formik.values.year}
                            onBlur={formik.handleBlur}
                            onChange={handleYearChange}
                            error={formik.touched.year && Boolean(formik.errors.year)}
                            disabled={formik.isSubmitting || isLoadingForm}
                          >
                            <MenuItem value={""}>Selecciona</MenuItem>
                            {listYears?.map((year, index) => (
                              <MenuItem key={index} value={year}>
                                {year}
                              </MenuItem>
                            ))}
                          </Select>
                          {formik.touched.year && formik.errors.year && (
                            <FormHelperText>{formik.errors.year}</FormHelperText>
                          )}
                        </FormControl>
                      )}
                    </>
                  )}

                  {vehicleType === "trucks" ? (
                    <>
                      <TextField
                        fullWidth
                        label="Marca"
                        name="brand"
                        value={formik.values.brand}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        id="brand"
                        margin="normal"
                        required
                        autoComplete="off"
                        error={formik.touched.brand && Boolean(formik.errors.brand)}
                        helperText={formik.touched.brand && formik.errors.brand}
                      />
                    </>
                  ) : (
                    <>
                      {isLoadingForm ? (
                        <Box sx={{ mt: 2 }}>
                          <Skeleton variant="rectangular" animation="wave" width={"100%"} height={56} />
                        </Box>
                      ) : (
                        <FormControl
                          fullWidth
                          required
                          sx={{
                            ...customStylesAsterisk,
                            mt: 3,
                          }}
                          error={formik.touched.brand && Boolean(formik.errors.brand)}
                        >
                          <InputLabel id="brand">Marca</InputLabel>
                          <Select
                            labelId="brand"
                            id="brand"
                            name="brand"
                            fullWidth
                            required
                            label="Marca"
                            value={formik.values.brand}
                            onBlur={formik.handleBlur}
                            onChange={handleBrandChange}
                            error={formik.touched.brand && Boolean(formik.errors.brand)}
                            disabled={formik.isSubmitting}
                          >
                            <MenuItem value={""}>Selecciona</MenuItem>
                            {brandsOptions?.map((b) => (
                              <MenuItem key={b.code} value={b.code}>
                                {b.name}
                              </MenuItem>
                            ))}
                          </Select>
                          {formik.touched.brand && formik.errors.brand && (
                            <FormHelperText>{formik.errors.brand}</FormHelperText>
                          )}
                        </FormControl>
                      )}
                    </>
                  )}

                  {vehicleType === "trucks" ? (
                    <>
                      <TextField
                        fullWidth
                        label="Modelo"
                        name="model"
                        value={formik.values.model}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        id="model"
                        margin="normal"
                        required
                        autoComplete="off"
                        error={formik.touched.model && Boolean(formik.errors.model)}
                        helperText={formik.touched.model && formik.errors.model}
                      />
                    </>
                  ) : (
                    <>
                      {isLoadingForm ? (
                        <Box sx={{ mt: 2 }}>
                          <Skeleton variant="rectangular" animation="wave" width={"100%"} height={56} />
                        </Box>
                      ) : (
                        <FormControl
                          fullWidth
                          required
                          sx={{
                            ...customStylesAsterisk,
                            mt: 3,
                          }}
                          error={formik.touched.model && Boolean(formik.errors.model)}
                        >
                          <InputLabel id="model">Modelo</InputLabel>
                          <Select
                            labelId="model"
                            id="model"
                            name="model"
                            fullWidth
                            required
                            label="Modelo"
                            value={formik.values.model}
                            onBlur={formik.handleBlur}
                            onChange={handleModelChange}
                            error={formik.touched.model && Boolean(formik.errors.model)}
                            disabled={formik.isSubmitting}
                          >
                            <MenuItem value={""}>Selecciona</MenuItem>
                            {modelsOptions?.map((m) => (
                              <MenuItem key={m.code} value={m.code}>
                                {m.name}
                              </MenuItem>
                            ))}
                          </Select>
                          {formik.touched.model && formik.errors.model && (
                            <FormHelperText>{formik.errors.model}</FormHelperText>
                          )}
                        </FormControl>
                      )}
                    </>
                  )}

                  {vehicleType === "trucks" ? (
                    <>
                      <TextField
                        fullWidth
                        label="Versión"
                        name="version"
                        value={formik.values.version}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        id="version"
                        margin="normal"
                        required
                        autoComplete="off"
                        error={formik.touched.version && Boolean(formik.errors.version)}
                        helperText={formik.touched.version && formik.errors.version}
                      />
                    </>
                  ) : (
                    <>
                      {isLoadingForm ? (
                        <Box sx={{ mt: 2 }}>
                          <Skeleton variant="rectangular" animation="wave" width={"100%"} height={56} />
                        </Box>
                      ) : (
                        <FormControl
                          fullWidth
                          required
                          sx={{
                            ...customStylesAsterisk,
                            mt: 3,
                          }}
                          error={formik.touched.version && Boolean(formik.errors.version)}
                        >
                          <InputLabel id="version">Versión</InputLabel>
                          <Select
                            labelId="version"
                            id="version"
                            name="version"
                            fullWidth
                            required
                            label="Versión"
                            value={formik.values.version}
                            onBlur={formik.handleBlur}
                            onChange={handleVersionChange}
                            error={formik.touched.version && Boolean(formik.errors.version)}
                            disabled={formik.isSubmitting}
                          >
                            <MenuItem value={""}>Selecciona</MenuItem>
                            {versionsOptions?.map((v) => (
                              <MenuItem key={v.code} value={v.code}>
                                {v.name}
                              </MenuItem>
                            ))}
                          </Select>
                          {formik.touched.version && formik.errors.version && (
                            <FormHelperText>{formik.errors.version}</FormHelperText>
                          )}
                        </FormControl>
                      )}
                    </>
                  )}

                  {vehicleType === "trucks" && (
                    <>
                      <TextField
                        fullWidth
                        label="Valor del vehículo"
                        name="price"
                        value={displayPrice}
                        onChange={(e) => {
                          if (submitError) setSubmitError("");
                          const raw = (e.target.value || "").replace(/[^\d]/g, "");
                          if (raw.length <= 10) {
                            const num = raw ? Number(raw) : 0;
                            setDisplayPrice(num ? new Intl.NumberFormat("es-MX").format(num) : "");
                            formik.setFieldValue("price", num || null);
                            setVehicleValue(num);
                          }
                        }}
                        onBlur={formik.handleBlur}
                        id="price"
                        margin="normal"
                        required
                        autoComplete="off"
                        error={formik.touched.price && Boolean(formik.errors.price)}
                        helperText={formik.touched.price && formik.errors.price}
                        disabled={formik.isSubmitting}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <AttachMoneyIcon fontSize="small" />
                            </InputAdornment>
                          ),
                          inputMode: "numeric",
                        }}
                        inputProps={{ maxLength: 11 }}
                      />
                    </>
                  )}

                  <Typography
                    textAlign={"center"}
                    variant={"body1"}
                    fontWeight={400}
                    color={theme?.palette?.primary?.dark}
                    mt={4}
                  >
                    Selecciona la cantidad
                  </Typography>

                  <Box
                    display={"flex"}
                    justifyContent={"center"}
                    gap={0.5}
                    mt={2}
                    flexWrap={"wrap"}
                    sx={{
                      "& > *": { marginX: isMobileOrTablet ? 0.3 : 0.5 },
                    }}
                  >
                    {isLoadingForm ? (
                      <Box sx={{ mt: 2 }}>
                        <Skeleton variant="rectangular" animation="wave" width={20} height={35} />
                      </Box>
                    ) : (
                      <>
                        {amount.map((item) => (
                          <ButtonTypeSelectedCustom
                            key={item}
                            title={String(item)}
                            onClick={() => formik.setFieldValue("carAmount", item)}
                            isSelected={formik.values.carAmount === item}
                            isMovile={isMobileOrTablet}
                            height={"35px"}
                            heightMoviles="35px"
                            width="22px"
                            widthMoviles="22px"
                            font_size="11px"
                            font_size_movil="11px"
                            font_weight={500}
                            bgColor={theme?.palette?.otherColors?.extra_light}
                            borderColor={theme?.palette?.primary?.light}
                            bgColorActive={theme?.palette?.primary?.light}
                            hoverBgColor={theme?.palette?.primary?.light}
                            hoverTextColor={theme?.palette?.primary?.dark}
                            textColor={theme?.palette?.primary?.dark}
                            textColorActive={theme?.palette?.primary?.dark}
                            padding={isMobileOrTablet ? 0 : 10}
                          />
                        ))}
                      </>
                    )}
                  </Box>

                  <Typography
                    textAlign={"center"}
                    variant={"body1"}
                    fontWeight={400}
                    color={theme?.palette?.primary?.dark}
                    mt={2}
                  >
                    Confirma el residual
                  </Typography>

                  <Box mt={1} mb={2}>
                    <StyledSlider
                      aria-label="amount"
                      min={configResidual.min}
                      max={configResidual.max}
                      step={configResidual.step}
                      marks={residualMarks}
                      defaultValue={configResidual.def}
                      value={selectedResidual}
                      onChange={(_event, newValue) => setSelectedResidual(newValue as number)}
                    />
                  </Box>

                  <Box>
                    <Typography
                      variant={isMobileOrTablet ? "body2" : "body1"}
                      fontWeight={400}
                      textAlign={"center"}
                      color={theme?.palette?.primary?.dark}
                    >
                      Valor del residual
                    </Typography>
                    <Typography
                      fontSize={"18px"}
                      fontWeight={600}
                      textAlign={"center"}
                      mt={1}
                      color={theme?.palette?.primary?.main}
                    >
                      {formatCurrency(vehicleValue * (formik.values.carAmount || 1) * (selectedResidual / 100))}{" "}
                      <Typography variant="body3" fontWeight={500}>
                        {interfaceConfig.cotizador?.current_currency || "MXN"}
                      </Typography>
                    </Typography>
                  </Box>

                  <Box display={"flex"} flexDirection={"row"} mt={4} mb={4}>
                    <Box width={"45%"}>
                      <Typography
                        variant={isMobileOrTablet ? "body2" : "body1"}
                        fontWeight={400}
                        textAlign={"center"}
                        color={theme?.palette?.primary?.dark}
                      >
                        Valor de los vehículos
                      </Typography>
                      <Typography
                        fontSize={"18px"}
                        fontWeight={600}
                        textAlign={"center"}
                        mt={1}
                        color={theme?.palette?.primary?.main}
                      >
                        {formatCurrency(vehicleValue * (formik.values.carAmount || 1))}{" "}
                        <Typography variant="body3" fontWeight={500}>
                          {interfaceConfig.cotizador?.current_currency || "MXN"}
                        </Typography>
                      </Typography>
                    </Box>

                    <Box width={"10%"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                      <Divider orientation="vertical" flexItem sx={{ mr: "-2px", border: "1px solid #F2704F" }} />
                    </Box>

                    <Box width={"45%"}>
                      <Typography
                        variant={isMobileOrTablet ? "body2" : "body1"}
                        fontWeight={400}
                        textAlign={"center"}
                        color={theme?.palette?.primary?.dark}
                      >
                        Monto a financiar
                      </Typography>

                      <Typography
                        fontSize={"18px"}
                        fontWeight={600}
                        textAlign={"center"}
                        color={theme?.palette?.primary?.main}
                        mt={1}
                      >
                        {formatCurrency(
                          vehicleValue * (formik.values.carAmount || 1) -
                            vehicleValue * (formik.values.carAmount || 1) * (selectedAdvance / 100),
                        )}{" "}
                        <Typography variant="body3" fontWeight={500}>
                          {interfaceConfig.cotizador?.current_currency || "MXN"}
                        </Typography>
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                    <Button
                      variant="default"
                      type="submit"
                      disabled={isLoadingForm || formik.isSubmitting || !formik.isValid}
                    >
                      {editIndex !== null ? "Actualizar Vehículo" : "Agregar Vehículo/s"}
                    </Button>
                  </Box>
                </form>
              </Box>
            }
          />

          <Box mt={1} mx={isMobileOrTablet ? 4 : 6}>
            <Typography
              textAlign={"center"}
              variant={"body1"}
              fontWeight={400}
              color={theme?.palette?.primary?.dark}
              mt={4}
            >
              Confirma el plazo en meses
            </Typography>

            <Box
              display={"flex"}
              justifyContent={"center"}
              gap={1}
              mt={2}
              flexWrap={"wrap"}
              sx={{
                "& > *": { marginX: 0.5 },
                cursor: isLoadingForm ? "not-allowed" : "default",
                pointerEvents: isLoadingForm ? "none" : "auto",
                opacity: isLoadingForm ? 0.6 : 1,
              }}
            >
              {terms.map((term) => (
                <ButtonTypeSelectedCustom
                  key={term}
                  title={String(term)}
                  onClick={() => setSelectedTerm(term)}
                  isSelected={selectedTerm === term}
                  isMovile={isMobileOrTablet}
                  height={"35px"}
                  heightMoviles="35px"
                  width="38.5px"
                  widthMoviles="38.5px"
                  font_size="11px"
                  font_size_movil="11px"
                  font_weight={500}
                  bgColor={theme?.palette?.otherColors?.extra_light}
                  borderColor={theme?.palette?.primary?.light}
                  bgColorActive={theme?.palette?.primary?.light}
                  hoverBgColor={theme?.palette?.primary?.light}
                  hoverTextColor={theme?.palette?.primary?.dark}
                  textColor={theme?.palette?.primary?.dark}
                  textColorActive={theme?.palette?.primary?.dark}
                />
              ))}
            </Box>

            <Typography
              textAlign={"center"}
              variant={"body1"}
              fontWeight={400}
              color={theme?.palette?.primary?.dark}
              mt={2}
            >
              Confirmar el anticipo
            </Typography>

            <Box mt={1} mb={2}>
              <StyledSlider
                aria-label="amount"
                min={configAdvance.min}
                max={configAdvance.max}
                step={configAdvance.step}
                marks={advancePercentageMarket}
                defaultValue={configAdvance.def}
                value={selectedAdvance}
                onChange={(_event, newValue) => setSelectedAdvance(newValue as number)}
                disabled={isLoadingForm}
              />
            </Box>

            <Box display={"flex"} flexDirection={"row"} mt={4} mb={4}>
              <Box width={"45%"}>
                <Typography
                  variant={isMobileOrTablet ? "body2" : "body1"}
                  fontWeight={400}
                  textAlign={"center"}
                  color={theme?.palette?.primary?.dark}
                >
                  Valor del anticipo
                </Typography>
                <Typography
                  fontSize={"18px"}
                  fontWeight={600}
                  textAlign={"center"}
                  mt={1}
                  color={theme?.palette?.primary?.main}
                >
                  {formatCurrency(leasingTotals.advanceAmount)}{" "}
                  <Typography variant="body3" fontWeight={500}>
                    {interfaceConfig.cotizador?.current_currency || "MXN"}
                  </Typography>
                </Typography>
              </Box>

              <Box width={"10%"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                <Divider orientation="vertical" flexItem sx={{ mr: "-2px", border: "1px solid #F2704F" }} />
              </Box>

              <Box width={"45%"}>
                <Typography
                  variant={isMobileOrTablet ? "body2" : "body1"}
                  fontWeight={400}
                  textAlign={"center"}
                  color={theme?.palette?.primary?.dark}
                >
                  Valor del residual
                </Typography>

                <Typography
                  fontSize={"18px"}
                  fontWeight={600}
                  textAlign={"center"}
                  color={theme?.palette?.primary?.main}
                  mt={1}
                >
                  {formatCurrency(leasingTotals.residualAmount)}{" "}
                  <Typography variant="body3" fontWeight={500}>
                    {interfaceConfig.cotizador?.current_currency || "MXN"}
                  </Typography>
                </Typography>
              </Box>
            </Box>

            <Box display={"flex"} flexDirection={"row"} mt={4} mb={4}>
              <Box width={"45%"}>
                <Typography
                  variant={isMobileOrTablet ? "body2" : "body1"}
                  fontWeight={400}
                  textAlign={"center"}
                  color={theme?.palette?.primary?.dark}
                >
                  Valor de los vehículos
                </Typography>
                <Typography
                  fontSize={"18px"}
                  fontWeight={600}
                  textAlign={"center"}
                  mt={1}
                  color={theme?.palette?.primary?.main}
                >
                  {formatCurrency(leasingTotals.totalValue)}{" "}
                  <Typography variant="body3" fontWeight={500}>
                    {interfaceConfig.cotizador?.current_currency || "MXN"}
                  </Typography>
                </Typography>
              </Box>

              <Box width={"10%"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                <Divider orientation="vertical" flexItem sx={{ mr: "-2px", border: "1px solid #F2704F" }} />
              </Box>

              <Box width={"45%"}>
                <Typography
                  variant={isMobileOrTablet ? "body2" : "body1"}
                  fontWeight={400}
                  textAlign={"center"}
                  color={theme?.palette?.primary?.dark}
                >
                  Monto a financiar
                </Typography>

                <Typography
                  fontSize={"18px"}
                  fontWeight={600}
                  textAlign={"center"}
                  color={theme?.palette?.primary?.main}
                  mt={1}
                >
                  {formatCurrency(leasingTotals.amountToFinance)}{" "}
                  <Typography variant="body3" fontWeight={500}>
                    {interfaceConfig.cotizador?.current_currency || "MXN"}
                  </Typography>
                </Typography>
              </Box>
            </Box>
            <Box>
              <Typography fontSize={"17px"} fontWeight={700} textAlign={"center"} color={theme?.palette?.primary?.main}>
                Renta mensual estimada
              </Typography>

              <Typography
                fontSize={"22px"}
                fontWeight={700}
                textAlign={"center"}
                color={theme?.palette?.primary?.dark}
                mt={1}
              >
                {formatCurrency(leasingTotals.monthlyRent)}{" "}
                <Typography variant="body3" fontWeight={700}>
                  {interfaceConfig.cotizador?.current_currency || "MXN"}
                </Typography>
              </Typography>

              <Box display={"flex"} justifyContent={"center"} mt={2}>
                <Button variant="default" disabled={isLoadingForm || vehicles.length === 0} onClick={handleContinue}>
                  Continuar
                </Button>
              </Box>
            </Box>
          </Box>
        </>
      )}
    </>
  );
};

export default FormByMultiVehicles;
